/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelectionTagSelectionValueTreeList } from '../../models/selection-tag-selection-value-tree-list';

export interface TagGetSelectionTagSelectionValueTreeList$Params {

/**
 * GUID of the tag
 */
  tagId: string;
}

export function tagGetSelectionTagSelectionValueTreeList(http: HttpClient, rootUrl: string, params: TagGetSelectionTagSelectionValueTreeList$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectionTagSelectionValueTreeList>> {
  const rb = new RequestBuilder(rootUrl, tagGetSelectionTagSelectionValueTreeList.PATH, 'get');
  if (params) {
    rb.path('tagId', params.tagId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelectionTagSelectionValueTreeList>;
    })
  );
}

tagGetSelectionTagSelectionValueTreeList.PATH = '/tag/selection/{tagId}/selection-value/tree-list';
